module.exports = __webpack_public_path__ + "static/img/1.742b509.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mockups/screenshots/1.jpg
// module id = RsMm
// module chunks = 0